import { createReducer, createActions } from 'reduxsauce';
import get from 'lodash-es/get';

const { Types, Creators } = createActions({
  setPropertiesLoadRequest: null,
  setPropertiesLoading: ['loading'],
  setPropertiesError: ['error'],
  setPropertiesList: ['properties'],
  setCurrentProperty: ['property']
});

export const PropertyTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  list: [],
  loading: true,
  error: null,
  data: null
};

/* ------- Selectors --------- */
export const PropertySelectors = {
  selectAllProperties: state => state.properties.list,
  selectPropertiesLoading: state => state.properties.loading,
  selectCurrentProperty: state => state.properties.data,
  selectPropertyId: state => get(state, 'properties.data.propertyID')
};

/* -------- Reducers ---------- */
export const setLoading = (state, { loading }) => ({
  ...state,
  loading
});

export const setError = (state, { error }) => ({
  ...state,
  error
});

export const setPropertiesList = (state, { properties }) => {
  return {
    ...state,
    list: properties
  };
};

export const setCurrentProperty = (state, { property }) => {
  return {
    ...state,
    data: property
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_PROPERTIES_LOADING]: setLoading,
  [Types.SET_PROPERTIES_ERROR]: setError,
  [Types.SET_PROPERTIES_LIST]: setPropertiesList,
  [Types.SET_CURRENT_PROPERTY]: setCurrentProperty
});
